import styled from 'styled-components';
import { device } from '../../styles/Responsive';

export const TimelineContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 30px;
  margin-bottom: 100px;

  @media ${device.tabletL} {
    display: none;
  }
`;

export const Column1 = styled.div`
  flex-basis: 50%;
  padding: 124px 0px;
`;

export const Column2 = styled.div`
  flex-basis: 50%;
  padding-top: 167px;
  padding-bottom: 117px;
  position: relative;
  border-left: 1px dashed #E0E0E0;
`;

export const Dot = styled.div`
  background-color: ${p => p.theme.menuBorderColor};
  border-radius: 100%;
  width: ${p => p.isFirst || p.isLast ? '9px' : '5px'};
  height: ${p => p.isFirst || p.isLast ? '9px' : '5px'};
  position: absolute;
  left: ${p => p.isFirst || p.isLast ? '-5px' : '-3px'};
  top: ${p => `${p.top}px`};

  @media ${device.mobileL} {
    display: none;
  }
`;

export const TimelineMobileContainer = styled.div`
  width: 100%;
  display: none;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 100px;

  @media ${device.tabletL} {
    display: flex;
  }
`;

export const MobileColumn = styled.div`
  flex-basis: 100%;
  padding: 124px 0px;
  margin: 0 15px;
  position: relative;
  border-left: 1px dashed #E0E0E0;

  @media ${device.mobileL} {
    border-left: 0;
    margin: 0 10px;
    padding: 15px 0px;
  }
`;


export const Container = styled.div`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  @media ${device.tablet} {
    flex-direction: column;
  }
`;

export const SelectContainer = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 30px;

  @media ${device.tablet} {
    max-width: 100%;
  }
`;

export const EmptyTimeline = styled.div`
  color: #000000;
  font-size: 20px;
  font-weight: 400;
  line-height: 31px;
  opacity: 0.5;
  padding: 0px 15px;
  padding-top: 30px;

  @media ${device.laptop} {
    font-size: 18px;
    line-height: 26px;
  }

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 22px;
  }

  @media ${device.mobileL} {
    padding: 0px 10px;
    padding-top: 30px;
  }
`;